<script>
import api from '@utils/api'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'CommunicationItem',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      newItem: {
        contact: null,
        type: null,
        value: null,
      },
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
    }
  },
  computed: {
    type() {
      return this.$store.getters['data/getDictionary']('communicationtype')
    },
    getName() {
      if (!this.newItem.contact) return this.newItem.contact
      const contact = this.$store.getters['data/getItemFromDictionary'](
        'contact',
        this.newItem.contact
      )
      return `${contact.firstName || ''} ${contact.middleName ||
        ''} ${contact.lastName || ''}`
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        Object.assign(this.newItem, this.item)
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
      this.$refs.itemForm.reset()
    },
    submit() {
      if (this.$refs.itemForm.validate()) {
        this.loading = true
        api.updateItem('contactcommunication', this.newItem).then(response => {
          this.$emit('communication-updated')
          this.$emit('close-modal')
          this.loading = false
          this.$refs.itemForm.reset()
        })
      }
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <div class="headline">{{ $t('titles__update_communication') }}</div>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="text-xs-center">
              <v-form ref="itemForm" v-model="valid" lazy-validation>
                <v-text-field
                  :label="$t('label__contact')"
                  :value="getName"
                  name="value"
                  autocomplete="off"
                  readonly
                />
                <v-select
                  :items="type"
                  :label="$t('label__type')"
                  :readonly="!userAllowedToUpdate"
                  v-model="newItem.type"
                  item-text="name"
                  item-value="code"
                />
                <v-text-field
                  :label="$t('label__value')"
                  :readonly="!userAllowedToUpdate"
                  v-model="newItem.value"
                  name="value"
                  autocomplete="off"
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="loading" color="secondary" @click="closeModal">{{
          $t('buttons__close')
        }}</v-btn>
        <v-btn
          v-if="userAllowedToUpdate"
          :loading="loading"
          :disabled="loading"
          color="success"
          @click="submit"
          >{{ $t('buttons__update') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
</style>
